import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "d-flex mt-5" }
const _hoisted_4 = { class: "col-md-1" }
const _hoisted_5 = { class: "col-sm-6 col-md-6" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_10 = { class: "col-sm-4 col-md-4" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 0,
  class: "fv-row mb-9 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid fv-bold"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "fv-row mb-9 fv-plugins-icon-container fv-plugins-bootstrap5-row-valid fv-bold"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "fv-plugins-message-container invalid-feedback" }, null, -1)
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "card-body py-3" }
const _hoisted_18 = { class: "table-responsive" }
const _hoisted_19 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Tanggal"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Sekolah"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Item"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px; text-center" }, "Aksi")
  ])
], -1)
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/detail.svg",
  alt: ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "6",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { class: "row mt-5 mb-5" }
const _hoisted_33 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_34 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_35 = ["label", "value"]
const _hoisted_36 = { class: "p-3" }
const _hoisted_37 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_38 = { class: "pagination" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-light",
              style: {"font-weight":"400","margin-top":"0px"},
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showHideFilter && _ctx.showHideFilter(...args)))
            }, " Filter ")
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showFilter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_ctx.role == 'ADMIN_SCHOOL')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_Field, {
                          type: "text",
                          name: "placeOfBirth",
                          class: "form-control form-control-lg",
                          placeholder: "Isi Tempat Lahir",
                          modelValue: _ctx.namasekolah,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.namasekolah) = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_Multiselect, {
                          modelValue: _ctx.schoolId,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.schoolId) = $event)),
                          placeholder: "Pilih Sekolah",
                          mode: "single",
                          "create-option": false,
                          options: _ctx.listSekolah,
                          searchable: true,
                          label: "name",
                          "track-by": "name",
                          "value-prop": "_id",
                          onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pilihSekolah($event)))
                        }, null, 8, ["modelValue", "options"])
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_ctx.showFilter)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_ctx.schoolId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createVNode(_component_el_date_picker, {
                          "picker-options": _ctx.pickerOptions,
                          modelValue: _ctx.dateAll,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateAll) = $event)),
                          type: "daterange",
                          "start-placeholder": "Tanggal Awal",
                          "end-placeholder": "Tanggal Akhir",
                          "value-format": "YYYY-MM-DD",
                          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.pilihTanggalAll()))
                        }, null, 8, ["picker-options", "modelValue"]),
                        _hoisted_13
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_el_date_picker, {
                          "picker-options": _ctx.pickerOptions,
                          type: "daterange",
                          "start-placeholder": "Tanggal Awal",
                          "end-placeholder": "Tanggal Akhir",
                          "value-format": "YYYY-MM-DD",
                          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pilihTanggalAll())),
                          disabled: ""
                        }, null, 8, ["picker-options"]),
                        _hoisted_15
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.downloads && _ctx.downloads(...args))),
            class: "btn btn-md btn-info"
          }, "Download")
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("table", _hoisted_19, [
            _hoisted_20,
            (_ctx.tableData.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_21, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.dateTime(item.createTime)), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(item.schoolName), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(item.item == "Migration" ? "Daftar ke PSP" : item.item), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createElementVNode("a", {
                          class: "symbol symbol-35px me-2",
                          "data-bs-toggle": "tooltip",
                          title: "Detail",
                          style: {"cursor":"pointer"},
                          onClick: ($event: any) => (_ctx.detailHistory(index, item))
                        }, _hoisted_28, 8, _hoisted_26)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_29, _hoisted_31))
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("select", {
                  name: "kt_customers_table_length",
                  class: "form-select form-select-sm form-select-solid",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.paging.size) = $event)),
                  placeholder: "Per page",
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changePageSize()))
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item,
                      label: item,
                      value: item
                    }, null, 8, _hoisted_35))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.paging.size]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1)
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("ul", _hoisted_38, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, " Previous ")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, " Next ")
              ], 2)
            ])
          ])
        ])
      ])
    ], 2)
  ], 64))
}